import React from 'react';
import CodeBlock from '../components/CodeBlock';

const Campaigns = () => {
  return (
    <div className="page">
      <div className="page-header">
        <h1>📢 Campaigns</h1>
        <p>
          Lister les campagnes, récupérer leur détail et les annuler à distance.
          La création de campagnes passe par l'UI Whakup (sélection contacts/groupes + scheduling).
        </p>
      </div>

      <div className="section">
        <h2>Lister les campagnes</h2>
        <div className="endpoint-card">
          <div className="endpoint-header">
            <span className="method-badge method-get">GET</span>
            <span className="endpoint-path">/api/v1/campaigns</span>
          </div>
          <h4>Query parameters</h4>
          <table className="params-table">
            <thead><tr><th>Param</th><th>Description</th></tr></thead>
            <tbody>
              <tr><td><code>page</code></td><td>Numéro de page (défaut 1)</td></tr>
              <tr><td><code>limit</code></td><td>Nombre par page (défaut 25, max 100)</td></tr>
            </tbody>
          </table>

          <h4>Statuts possibles</h4>
          <table className="params-table">
            <thead><tr><th>Code</th><th>Status</th></tr></thead>
            <tbody>
              <tr><td>0</td><td>DRAFT</td></tr>
              <tr><td>1</td><td>PROGRAMMED</td></tr>
              <tr><td>2</td><td>INPROGRESS</td></tr>
              <tr><td>3</td><td>PAUSE</td></tr>
              <tr><td>4</td><td>STOPPED</td></tr>
              <tr><td>5</td><td>FINISHED</td></tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="section">
        <h2>Détail d'une campagne</h2>
        <div className="endpoint-card">
          <div className="endpoint-header">
            <span className="method-badge method-get">GET</span>
            <span className="endpoint-path">/api/v1/campaigns/{'{id}'}</span>
          </div>
        </div>
      </div>

      <div className="section">
        <h2>Annuler une campagne</h2>
        <div className="endpoint-card">
          <div className="endpoint-header">
            <span className="method-badge method-post">POST</span>
            <span className="endpoint-path">/api/v1/campaigns/{'{id}'}/cancel</span>
          </div>
          <p>
            Stoppe une campagne en cours, programmée, ou en pause. Les statuts FINISHED ou STOPPED
            ne sont pas modifiables (HTTP 400).
          </p>

          <CodeBlock language="bash" code={`curl -X POST https://api.whakup.com/api/v1/campaigns/42/cancel \\
  -H "Authorization: Bearer YOUR_JWT" \\
  -H "X-Workspace-Id: 42"`} />
        </div>
      </div>

      <div className="section">
        <h2>Webhook campaign.completed</h2>
        <p>
          Pour être notifié de la fin d'une campagne, abonnez-vous au webhook <code>campaign.completed</code>.
          Voir la <a href="/webhooks">page Webhooks</a>.
        </p>
      </div>

      <div className="section">
        <h2>Scopes requis</h2>
        <ul>
          <li><code>campaigns:read</code> pour les <code>GET</code></li>
          <li><code>campaigns:write</code> pour le <code>POST /cancel</code></li>
        </ul>
      </div>
    </div>
  );
};

export default Campaigns;
